import { call, restService } from './apiHelpers';

export const userService = {
  ...restService('users'),
  getForActor: (_, filters) => call('get', 'users/', null, filters),
  getSupervisorOptions: (role) =>
    call('get', 'users/supervisor-options/', null, { role }),
  async createForActor(payload) {
    const result = await call('post', 'users/', payload);
    return {
      ...result,
      meta: {
        initialPassword: result.data.initial_password,
        mustChangePassword: result.data.must_change_password,
      },
    };
  },
  updateForActor: (id, payload) => call('patch', `users/${id}/`, payload),
  activate: (id) => call('post', `users/${id}/activate/`, {}),
  deactivate: (id) => call('post', `users/${id}/deactivate/`, {}),
  async resetPassword(id) {
    const result = await call('post', `users/${id}/reset-password/`, {});
    return {
      ...result,
      meta: {
        initialPassword: result.data.initial_password,
        mustChangePassword: result.data.must_change_password,
      },
    };
  },
};
